/**
 * PURPOSE:
 * Renderizar un casillero público y compacto dentro de la llave del evento 17.
 *
 * RESPONSIBILITIES:
 * - Mostrar la etiqueta del participante según moodName (FTR-0006: moodName 1 => abrev;
 *   en otro caso displayName || Institution.name).
 * - Mostrar el origen deportivo del cupo cuando todavía está vacío.
 * - Mantener estilos suaves para pase directo, ganador, perdedor y mejor perdedor.
 *
 * COLLABORATORS:
 * - Event17PublicBracketMatch.jsx
 * - Event17PublicBracketConnectors.jsx
 *
 * ROUTE:
 * src/components/Fixture/components/Event17PublicBracketSlot.jsx
 */
import React from "react";
import { getParticipantLabel } from "../../../utils/participantDisplayName.js";

const SOURCE_STYLES = {
  BEST_LOSER: "border-amber-200 bg-amber-50 text-amber-900",
  DIRECT: "border-blue-200 bg-blue-50 text-blue-900",
  LOSER: "border-violet-200 bg-violet-50 text-violet-900",
  WINNER: "border-slate-200 bg-slate-50 text-slate-700",
  SEED: "border-slate-200 bg-white text-slate-800",
};

export default function Event17PublicBracketSlot({ slot, moodName }) {
  const participant = slot?.participant || null;
  const institution = participant?.institution || null;
  const sourceType = slot?.sourceType || "SEED";
  const pendingStyle = SOURCE_STYLES[sourceType] || SOURCE_STYLES.SEED;
  // FTR-0006: moodName 1 => abrev; otro caso => displayName || name.
  // El nombre queda como respaldo si el backend aún no expone abrev/displayName.
  const visibleName =
    getParticipantLabel(participant, moodName) ||
    institution?.name ||
    slot?.sourceLabel ||
    "Por definir";

  return (
    <div
      data-slot-side={slot?.side}
      className={`flex min-h-[42px] items-center gap-2.5 rounded-lg border px-2.5 py-1.5 ${
        institution ? "border-slate-200 bg-white text-slate-900" : pendingStyle
      }`}
    >
      <div className="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-slate-200">
        {institution?.logo ? (
          <img
            src={institution.logo}
            alt={visibleName}
            className="h-full w-full object-contain p-1"
            loading="lazy"
          />
        ) : (
          <span className="text-sm font-semibold text-slate-300">—</span>
        )}
      </div>

      <span
        className="min-w-0 flex-1 truncate text-[13px] font-semibold"
        title={visibleName}
      >
        {visibleName}
      </span>
    </div>
  );
}
